import { gql } from 'graphql-request';
import { client } from '@/graph/client';
import { listUrlShortener } from './types/list';
import { createUrlShortener } from './types/create';
import { servicecloudUrlShortenerVariantsResponse, variantsUrlShortener } from './types/variants';

export type UrlShortenList = {
    page: number,
    total: number,
    entries: UrlShorten[],
}

export type UrlShorten = {
    identifier: string,
    path: string,
    target: string,
    redisid: string,
    description: string,
    createdby: string,
    created: string,
    hasVariants: boolean,
}

export type UrlShortenCreateResponse = {
    success: boolean,
    path: string,
    error: string,
}

class UrlShortener
{
    public async create(url: string, user: string, description: string, requestPath: string): Promise<UrlShortenCreateResponse>
    {
        const out: UrlShortenCreateResponse = {
            success: false,
            path: "",
            error: "Unknown Error",
        }

        const query = gql`
			mutation shortenUrl($url: String!, $user: String, $description: String, $requestPath: String)
            {
                shortenUrl(
                    url: $url
                    user: $user
                    description: $description
                    requestPath: $requestPath
                )
                {
                    id
                    path
                    url
                    created {
                        atom
                    }
                }
            }
		`;

        try {

            const response = await client.request<createUrlShortener>(query, {
                url,
                user,
                description,
                requestPath,
            });

            console.log("UrlShortener.create", response);

            if(response.shortenUrl)
            {
                out.success = true;
                out.path = response.shortenUrl.path;
                out.error = "";
            }

        }
        catch(error)
        {
            // console.error(JSON.stringify(error, undefined, 2));
            console.error(JSON.stringify(error.response.errors[0].debugMessage, undefined, 2));

            out.success = false;
            out.path = "";
            out.error = error.response.errors[0].debugMessage;
        }

        return out;
    }

	public async list(page: number): Promise<UrlShortenList>
	{
		const out:UrlShortenList = {
            page: page,
            total: 0,
            entries: [],
        };

		const query = gql`
			query urlShortenerList($page: Int!) {
				urlShortenerList(page: $page)
                {
                    total
                    entries {
                        identifier
                        path
                        target
                        redisid
                        description
                        createdby
                        created {
                            atom
                        }
                        hasVariants
                    }
                }
			}
		`;

		const response = await client.request<listUrlShortener>(query, {
            page
        });

		console.log("UrlShortener.list", response);

		if(response.urlShortenerList.total)
        {
            out.total = response.urlShortenerList.total;
        }

		if(response.urlShortenerList.entries)
		{
			for(const entry of response.urlShortenerList.entries)
			{
				if(entry)
				{
					out.entries.push({
						identifier: entry.identifier,
                        path: entry.path,
                        target: entry.target,
                        redisid: entry.redisid,
                        description: entry.description,
                        createdby: entry.createdby,
                        created: entry.created.atom,
                        hasVariants: entry.hasVariants ?? false,
					});
				}
			}
		}

		return out;
	}

    public async listVariants(path: string): Promise<servicecloudUrlShortenerVariantsResponse | null>
    {
        console.log("UrlShortener.listVariants", "path", path);

        const query = gql`
			query urlShortenerVariants($path: String!) {
                urlShortenerVariants(path: $path)
                {
                    amount
                    variants {
                        path
                        parameters {
                            key
                            value
                        }
                    }
                }
            }
		`;

        const response = await client.request<variantsUrlShortener>(query, {
            path
        });

        console.log("UrlShortener.listVariants", "response", response);

        if(response.urlShortenerVariants !== null)
        {
            return response.urlShortenerVariants;
        }

        return null;
    }
}

export default new UrlShortener();
